import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from "react";
import { api } from "./api";
import type { Content, User } from "./types";

type AppState = {
  content: Content | null;
  user: User | null;
  loading: boolean;
  refresh: () => Promise<void>;
  refreshUser: () => Promise<void>;
};

const AppContext = createContext<AppState | null>(null);

export function AppProvider({ children }: { children: ReactNode }) {
  const [content, setContent] = useState<Content | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setContent(await api<Content>(""));
  }, []);

  const refreshUser = useCallback(async () => {
    const result = await api<{ user: User | null }>("/auth/me");
    setUser(result.user);
  }, []);

  useEffect(() => {
    Promise.all([refresh(), refreshUser()]).finally(() => setLoading(false));
  }, [refresh, refreshUser]);

  return (
    <AppContext.Provider value={{ content, user, loading, refresh, refreshUser }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const value = useContext(AppContext);
  if (!value) throw new Error("AppProvider chybí.");
  return value;
}
